<template>
    <div>
        <dialog ref="dialog" class="calendar-popup" id="calendar-popup">
            <div class="calendar-popup__inner">
                <button
                    class="calendar-popup__close"
                    type="button"
                    data-dialog-close
                    @click="closeDialog"
                >
                    Close
                    <Icon name="close-circle" />
                </button>

                <div class="calendar-popup-item" v-if="event">
                    <figure
                        v-if="event.image"
                        class="calendar-popup-item__media"
                        itemscope
                        itemtype="http://schema.org/ImageObject"
                    >
                        <picture
                            class="calendar-popup-item__intrinsic-ratio media media-image"
                        >
                            <source
                                :srcset="`${imageUrl(event, { width: 600, height: 400 })}, ${imageUrl(event, { width: 1200, height: 800 })} 2x`"
                                media="(max-width: 799px)"
                            />
                            <source
                                :srcset="`${imageUrl(event, { width: 500, height: 350 })}, ${imageUrl(event, { width: 1000, height: 700 })} 2x`"
                                media="(min-width: 800px)"
                            />

                            <img
                                class="calendar-popup-item__image"
                                :src="
                                    imageUrl(event, { width: 600, height: 400 })
                                "
                                width="600"
                                height="400"
                                :alt="event.image.alt"
                            />
                        </picture>
                    </figure>

                    <div class="calendar-popup-item__body">
                        <span
                            v-if="event.prefix"
                            class="calendar-popup-item__prefix"
                            >{{ event.prefix }}</span
                        >
                        <h2 class="calendar-popup-item__title">
                            {{ event.title }}
                        </h2>
                        <span
                            v-if="event.suffix"
                            class="calendar-popup-item__suffix"
                            >{{ event.suffix }}</span
                        >

                        <p class="calendar-popup-item__date">
                            <strong>{{ formattedDate }}</strong> at
                            <strong>{{ event.formattedTime }}</strong>
                        </p>

                        <p
                            class="calendar-popup-item__venue"
                            v-if="event.venue"
                        >
                            {{ event.venue.title }}
                        </p>

                        <div
                            class="calendar-popup-item__footer"
                            v-if="
                                (event.filters && event.filters.categories) ||
                                event.availability
                            "
                        >
                            <calendar-info :event="events"/>
                        </div>

                        <div
                            class="calendar-popup-item__description"
                            v-if="event.description"
                            v-html="event.description"
                        ></div>

                        <div
                            class="calendar-popup-item__actions"
                            v-if="event.ctaPrimary || event.ctaSecondary"
                        >
                            <a
                                v-if="event.ctaSecondary"
                                :href="event.ctaSecondary.link"
                                class="calendar-popup-item__btn btn btn--theme-dark-outline"
                            >
                                {{ event.ctaSecondary.title }}
                            </a>
                            <a
                                v-if="event.ctaPrimary"
                                :href="event.ctaPrimary.link"
                                class="calendar-popup-item__btn btn btn--theme-dark"
                            >
                                {{ event.ctaPrimary.title }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </dialog>
    </div>
</template>

<script setup>
import { format } from 'date-fns';
import { computed, inject, ref, watch } from 'vue';
import Icon from '../../js/components/Icon.vue';
import CalendarInfo from "./calendar-info.vue";

const props = defineProps({
    event: {
        type: Object,
        default: null
    }
});

const emit = defineEmits(['close']);

const dialog = ref(null);
const imageUrl = inject('imageUrl');

const formattedDate = computed(() => {
    if (props.event && Object.keys(props.event).length) {
        return format(props.event.startDate, 'EEE, MMM d');
    }
});

const closeDialog = () => {
    dialog.value.close();
    emit('close');
};

// // Watch for event changes to open/close dialog
// watch(() => props.event, (newEvent) => {
//     if (newEvent) {
//         dialog.value.showModal();
//     } else {
//         dialog.value.close();
//     }
// });

defineExpose({
    openDialog: () => dialog.value.showModal(),
    closeDialog
});
</script>
